import { ActivateDeactiveteClientAccountRequest, ActivateDeactiveteContactRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// Activate/deactivate for the record the Details tab renders — a client
// account or a contact, picked by the host's clientAccountsEnabled flag.
export default function useAccountDetailsTab(clientAccountsEnabled: boolean) {
  const api = useApi();
  const [updating, setUpdating] = useState(false);

  const accountTypeLabel: 'Client Account' | 'Contact' = clientAccountsEnabled ? 'Client Account' : 'Contact';

  async function activateAccount(params: ActivateDeactiveteClientAccountRequest | ActivateDeactiveteContactRequest) {
    try {
      setUpdating(true);

      const res = clientAccountsEnabled
        ? await api.activateClientAccount(params as ActivateDeactiveteClientAccountRequest)
        : await api.activateContact(params as ActivateDeactiveteContactRequest);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setUpdating(false);
    }
  }

  async function deactivateAccount(params: ActivateDeactiveteClientAccountRequest | ActivateDeactiveteContactRequest) {
    try {
      setUpdating(true);

      const res = clientAccountsEnabled
        ? await api.deactivateClientAccount(params as ActivateDeactiveteClientAccountRequest)
        : await api.deactivateContact(params as ActivateDeactiveteContactRequest);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setUpdating(false);
    }
  }

  return {
    accountTypeLabel,
    updating,
    activateAccount,
    deactivateAccount,
  };
}
